import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function FinanceMenu({ openItem, activeItem }) {
  return (
    <li
      className={`nav-item has-treeview 
      ${sidebarHelper.checkOpenItem(openItem, "finance")} `}
    >
      <a
        href="# "
        className={`nav-link  
        ${sidebarHelper.checkActiveItem(openItem, "finance")} `}
      >
        <i className="nav-icon hl-money align-middle"></i>
        <p>
          مالی
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/finance/all-wallet-log-position"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-wallet-log-position"
          )} `}
          >
            <i class="fa-solid fa-money-bill-trend-up pl-2"></i>
            <p>گزارش مالی جایگاه ها</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/finance/ask-transaction/all"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(activeItem, "all-ask-transaction")} `}
          >
            <i class="fa-solid fa-comments-dollar pl-2"></i>
            <p>درخواست انتقال موجودی</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/finance/all-score-log-position"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-score-log-position"
          )} `}
          >
            <i class="fa-solid fa-chart-pie pl-2"></i>
            <p>گزارش امتیاز جایگاه ها</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/finance/all-transaction-score-to-wallet-advertiser"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-transaction-score-to-wallet-advertiser"
          )} `}
          >
            <i class="fa-solid fa-arrow-right-arrow-left pl-2"></i>
            <p>تبدیل امتیاز به موجودی</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
